export default {
  RecruitmentBulkImport: {
    mounted() {
      window.recruitmentImport = this;

      // No need to load this feature on mobile devices
      const isMobile = window.matchMedia('only screen and (max-width: 768px)').matches;
      if (isMobile) {
        return;
      }

      const spreadsheetContainer = this.el.querySelector('.recruitment-bulk-import-spreadsheet');

      this.columns = this.getColumns(spreadsheetContainer.dataset.columns);

      // Collect all dependent field columns
      this.dependentColumns = this.columns.filter((x) => x.controlling_field_api_name);

      this.hot = window.Handsontable(spreadsheetContainer, {
        colHeaders: true,
        columns: this.columns,
        colWidths: 120,
        contextMenu: {
          items: {
            row_above: {},
            row_below: {},
            row_below_10: {
              name: 'Insert 10 rows below',
              callback: () => {
                this.hot.alter('insert_row', 499, 10);
              },
            },
            sep1: '---------',
            remove_row: {},
            sep2: '---------',
            undo: {},
            redo: {},
            sep3: '---------',
            copy: {},
            cut: {},
          },
        },
        manualColumnResize: true,
        maxRows: 500,
        minRows: 25,
        preventOverflow: 'horizontal',
        rowHeaders: true,
        stretchH: 'all',
        beforePaste: (data, coords) => {
          if (data && coords) {
            // We want to convert key-value pair data so it pastes correctly

            // Determine the range and location of the pasted content
            const { startRow, startCol } = coords[0];
            const endRow = startRow + data.length;
            const endCol = startCol + data[0].length;

            for (let rowIndex = startRow, row = 0; rowIndex < endRow; rowIndex += 1, row += 1) {
              for (let colIndex = startCol, col = 0; colIndex < endCol; colIndex += 1, col += 1) {
                const value = data[row][col];

                if (value && this.hot.getDataType(rowIndex, colIndex) === 'key-value') {
                  // Get column's properties
                  const colProps = this.columns[colIndex];

                  // Get the key-value pair for the given data
                  // We match on either key or value
                  const option = colProps.source.find((x) => x.key === value || x.value === value);

                  // If found, paste key instead of value
                  if (option) {
                    // eslint-disable-next-line no-param-reassign
                    data[row][col] = option.key;
                  }
                }
              }
            }
          }
        },
        // eslint-disable-next-line no-unused-vars
        afterChange: (changes, source) => {
          // Get dependent picklist options
          if (changes) {
            changes.forEach(([row, col, oldValue, newValue]) => {
              // If a key-value type column is found, attempt to render
              // the options for any of its dependent fields
              if (this.hot.getDataType(row, col) === 'key-value') {
                const colProps = this.columns[col];

                // Find all dependent columns for this column
                const dependentCols = this.dependentColumns.filter(
                  (x) => x.controlling_field_api_name === colProps.api_name,
                );

                // If dependent columns found
                if (dependentCols.length > 0) {
                  dependentCols.forEach((depCol) => {
                    // Get dependent column index, so we can use it to modify its options
                    const depColIndex = this.columns.findIndex(
                      (x) => x.api_name === depCol.api_name,
                    );

                    // If the new controller field value is different from the previous one
                    // Clear out the dependent field values since the options will now be different
                    if (oldValue !== newValue) {
                      this.hot.setDataAtCell(row, depColIndex, '');
                    }

                    // Request server for the picklist options for given dropdown
                    // based on its controller field's value
                    this.pushEvent(
                      'dependent-options',
                      { dependentField: depCol, controllerValue: newValue },
                      // eslint-disable-next-line no-unused-vars
                      (reply, ref) => {
                        if (reply && 'options' in reply) {
                          this.hot.setCellMetaObject(row, depColIndex, {
                            editor: 'key-value', // Re-enable since it's disabled on page load
                            source: reply.options, // Add options
                          });
                        }
                      },
                    );
                  });
                }
              }
            });
          }
        },
      });
    },

    submit() {
      // If Handsontable has been initialized
      if (this.hot) {
        // Give immediate feedback to user while we wait for a server response
        this.el.querySelector('#recruitment-bulk-submit').classList.add('is-loading');

        const newLeads = [];

        // Collect all Date columns
        const dateColumns = this.columns.reduce((indices, field, index) => {
          if (field.type === 'date') {
            indices.push(index);
          }
          return indices;
        }, []);

        // Get new Leads data, but ignore empty rows
        this.hot.getData().forEach((object, rowIndex) => {
          if (!this.hot.isEmptyRow(rowIndex)) {
            // Massage data for submission
            const parsedObject = object.map((value, colIndex) => {
              let v = value;

              // Change date format from mm/dd/yyyy to yyyy-mm-dd
              if (dateColumns.includes(colIndex)) {
                v = window.formatDateISO(value);
              } else if (typeof value === 'number') {
                v = value.toString();
              }

              return v;
            });

            newLeads.push(parsedObject);
          }
        });

        this.pushEvent(
          'bulk-import',
          {
            status: this.el.querySelector('select#bulk-import-form_status').value,
            new_leads: newLeads,
          },
          // eslint-disable-next-line no-unused-vars
          (reply, ref) => {
            // We want to clear out the sheet, and insert back in the errant changeset data
            if (reply && 'status' in reply) {
              switch (reply.status) {
                case 'error': {
                  if ('invalid_data' in reply && reply.invalid_data) {
                    const newData = reply.invalid_data.map((data) => {
                      const newRow = [];
                      this.columns.forEach((col) => {
                        newRow.push(data[col.api_name]);
                      });

                      return newRow;
                    });

                    this.hot.loadData(newData);

                    // Mark rows as invalid
                    if (newData) {
                      this.hot.getData().forEach((object, rowIndex) => {
                        if (!this.hot.isEmptyRow(rowIndex)) {
                          this.columns.forEach((col, colIndex) => {
                            this.hot.setCellMeta(rowIndex, colIndex, 'valid', false);
                          });

                          // We must re-render on changing cell meta properties
                          this.hot.render();
                        }
                      });
                    }
                  }
                  break;
                }
                case 'success': {
                  this.hot.loadData([]);
                  break;
                }
                default:
                  break;
              }
            }

            this.el.querySelector('#recruitment-bulk-submit').classList.remove('is-loading');
          },
        );
      }
    },

    getColumns(columnsString) {
      // Get columns data from JSON
      // Then, construct title for Handsontable column header
      return JSON.parse(columnsString).map((col) => ({
        ...col,
        title: col.label + this.maybeGetRequiredSign(col),
      }));
    },

    maybeGetRequiredSign(col) {
      return col['required?'] ? '<span class="profile-field-required">*</span>' : '';
    },
  },
};
